var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-breadcrumb',{attrs:{"title":_vm.pageTitle,"routes":_vm.routes}}),(_vm.datas.length > 0)?_c('vx-card',[_c('video-player',{attrs:{"options":_vm.videoOptions}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }